var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrane = function SvgCrane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 511 511"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511 173V82h-40.8L367.42 19.56V1h-30v15.08L53.28 82H0v91h50.26v34.72H28.05v72.56h22.21V312h30v-31.72h20.35v-72.56H80.26V173h220.88v168.99l-54.46 66.66V510h211.48V408.65l-54.45-66.66V173zM301.14 480h-24.46v-60.65l24.46-29.94zm49.37-307-19.37 17.99V173zM186.03 82l151.39-35.12V82zm180.63 210.79-35.52 33V259.8zM331.14 394.6l35.52 33-35.52 33zm42.57 85.4h-19.38l19.38-18zm0-86.81-35.53-33 35.53-32.99zm0-134.8-35.53-32.99 35.53-33zm54.45 160.96V480h-24.45v-90.59zM367.42 82V54.66l45 27.34z"
  })));
};
export default SvgCrane;